import React, { useEffect, useState, useCallback } from "react";
import Button from "components/atoms/Button";
import CodeInput from "components/atoms/CodeInput";
import PageTitle from "components/atoms/PageTitle";
import forgotPasskey from "../../../assets/svg/forgotPassKey.svg";
import { useLocation, useNavigate } from "react-router-dom";
import Alert from "components/atoms/Alert";
import {
  BASE_URL,
  postRequest,
  getRequest,
  loggedUser_baseURL,
} from "services/http";
import { setValues } from "services/storage";
import { connect } from "react-redux";
import { setAuthRes, setUserLoggedIn } from "redux/auth/auth.action";

const Validate2fa = (props) => {
  const [loading, setLoading] = useState(false);
  const [OTPChange, setOTPChange] = useState("");
  const [progressData, setProgressData] = useState<any>([]);
  const [OTP, setOTP] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const userInfo = location?.state?.userData !== undefined ? true : false;

  useEffect(() => {
    if (!userInfo) {
      navigate("/auth/login");
    }
  }, [navigate, userInfo]);

  const redirectFunction = (url) => {
    return navigate(url, {
      state: progressData,
    });
  };

  const headers = {
    "Content-Type": "application/json",
  };

  const formComplete = OTP.length === 6;
  const disabledBtn = formComplete === false || loading === true;

  const onboardingProgress = useCallback(async (token: string) => {
    try {
      const res = await getRequest(
        `${BASE_URL + loggedUser_baseURL}partner/progress`,
        {
          ...headers,
          Authorization: `Bearer ${token}`,
        }
      );

      const data = res?.data?.data;

      if (res?.data?.responseCode === "00") {
        if (data.kycInfo === "PENDING") {
          return { status: "PENDING", route: "/auth/kyc_info" };
        }
        if (data.emails === "PENDING") {
          return { status: "PENDING", route: "/auth/emails_info" };
        }
        if (data.settlement === "PENDING") {
          return { status: "PENDING", route: "/auth/settlement_info" };
        }
        if (
          data.kycInfo === "COMPLETED" &&
          data.emails === "COMPLETED" &&
          data.settlement === "COMPLETED"
        ) {
          return { status: "COMPLETE" };
        }
      }

      return {
        status: "ERROR",
        message: res?.data?.message || "Unknown error",
      };
    } catch (err) {
      return {
        status: "ERROR",
        message: "Failed to fetch onboarding progress",
      };
    }
  }, [headers]);
  
  
  

  const verifyOTPforMFA = async (reqData: any) => {
    setLoading(true);
    try {
      const headers = { "Content-Type": "application/json" };

      const res = await postRequest(
        `${BASE_URL}auth/login/mfa`,
        { headers },
        reqData
      );

      if (res?.data?.responseCode === "00") {
        const token = res.data.data?.token?.token;

        if (token) {
          setValues("auth_token", token);
        }

        const next = await onboardingProgress(token);

        if (next.status === "PENDING" && next.route) {
          props.setAuthRes({
            ...props.user_authData,
            token,
            ...res.data.data,
          });
          props.setUserLoggedIn(false);
          navigate(next.route, { state: { token } });
        } else if (next.status === "COMPLETE") {
          Alert("success", "Login was successful");
          props.setUserLoggedIn(true);
          props.setAuthRes({
            ...props.user_authData,
            token,
            ...res.data.data,
          });
        } else if (next.status === "ERROR") {
          Alert("error", next.message);
        }
      } else {
        Alert("error", res?.data?.message || "OTP verification failed");
      }
    } catch (error) {
      Alert("error", "Something went wrong while verifying OTP");
    } finally {
      setLoading(false);
    }
  };
  

  const handleSubmit = (e) => {
    e.preventDefault();

    const reqData = {
      email: location?.state?.userData?.email,
      password: location?.state?.userData?.password,
      otp: OTP,
      category: "MULTI_FACTOR_AUTHENTICATION",
    };
    if (OTP !== "") {
      verifyOTPforMFA(reqData);
    } else {
      Alert("error", "Invalid, OTP cannot be empty.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-3">
      <img
        src={forgotPasskey}
        alt="SeerbitLogo"
        className="w-[40px] h-[40px]"
      />
      <PageTitle
        pageTitle="User Verification"
        pageTitleStyle="font-semibold !text-2xl tablet:!text-xl"
        subTitle="You have 2FA Configured and Enabled"
        subTitleStyle="!text-sm leading-7 !text-Black2"
      />
      <span className="flex flex-col gap-5">
        <div>
          <CodeInput
            label="Enter the OTP you just received in your mail"
            labelStyle="font-normal text-sm leading-6 text-Black2"
            length={6}
            onChange={(v) => setOTPChange(v)}
            type={"numeric"}
            secret={false}
            onComplete={(p) => setOTP(p)}
          />
        </div>

        <Button
          btnType="submit"
          btnText={loading ? "Loading..." : "Verify"}
          btnStyle={`${
            disabledBtn ? "cursor-not-allowed" : ""
          } bg-black text-white px-6 py-3 w-full`}
          disabled={disabledBtn}
        />
      </span>
    </form>
  );
};

const mapStateToProps = (state: any) => ({
  user_authData: state.auth.user_authData,
  user_loggedIn: state.auth.user_loggedIn,
  bearerToken: state.auth.user_authData?.token,
});

const mapDispatchToProps = (dispatch: any) => ({
  setAuthRes: (data: any[]) => dispatch(setAuthRes(data)),
  setUserLoggedIn: (data: boolean) => dispatch(setUserLoggedIn(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Validate2fa);
